<template>
  <aside class="app-sidebar">
    <div class="app-sidebar__user text-center">
      <img
        v-if="account"
        class="mb-3"
        :src="`data:image/png;base64,${account.image}`"
        alt="User Image"
        width="100"
      />
      <img
        v-else
        class="mb-3"
        src="@/assets/user.png"
        alt="User Image"
        width="120"
      />
      <div v-if="isAuthenticated">
        <p class="app-sidebar__user-name">{{ user.name }}</p>
        <p class="app-sidebar__user-designation">{{ account.job_position }}</p>
        <p class="app-sidebar__user-designation">
          <span v-if="account.department">{{ account.department.name }}</span>
        </p>
      </div>
    </div>
    <ul class="app-menu">
      <li>
        <router-link :to="{ name: 'dashboard' }" class="app-menu__item">
          <i class="bi bi-speedometer app-menu__icon"></i>
          <span class="app-menu__label">หน้าหลัก</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'requeststop' }" class="app-menu__item">
          <i class="bi bi-calendar-x app-menu__icon"></i>
          <span class="app-menu__label">ขอวันหยุด</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'CreateOverTime' }" class="app-menu__item">
          <i class="bi bi-file-earmark-plus app-menu__icon"></i>
          <span class="app-menu__label">เขียนใบเสริม</span>
        </router-link>
      </li>
      <!-- MANAGER -->
      <div v-if="user && user.role == 'manager'">
        <li>
          <router-link :to="{ name: 'managework' }" class="app-menu__item">
            <i class="bi bi-calendar-plus app-menu__icon"></i>
            <span class="app-menu__label">จัดการเวร</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'UserGroupBy' }" class="app-menu__item">
            <i class="bi bi-person-fill app-menu__icon"></i>
            <span class="app-menu__label">เจ้าหน้าที่หน่วยงาน</span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'WorkGroupTableTypeNote' }"
            class="app-menu__item"
          >
            <i class="bi bi-list-task app-menu__icon"></i>
            <span class="app-menu__label">จัดการหมายเหตุตารางเวร</span>
          </router-link>
        </li>
      </div>
      <!-- ADMIN -->
      <div v-if="user && user.role == 'admin'">
        <li>
          <router-link
            :to="{ name: 'managework' }"
            class="app-menu__item text-warning"
          >
            <i class="bi bi-calendar2-plus app-menu__icon"></i>
            <span class="app-menu__label">จัดการเวร</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'usergroup' }" class="app-menu__item">
            <i class="bi bi-people app-menu__icon"></i>
            <span class="app-menu__label">เจ้าหน้าที่</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'workgroup' }" class="app-menu__item">
            <i class="bi bi-building app-menu__icon"></i>
            <span class="app-menu__label">กลุ่มงาน</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'endorser' }" class="app-menu__item">
            <i class="bi bi-person-check app-menu__icon"></i>
            <span class="app-menu__label">ผู้ลงนามรับรอง</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'workshifttype' }" class="app-menu__item">
            <i class="bi bi-list-task app-menu__icon"></i>
            <span class="app-menu__label">ประเภทเวร</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'tabletype' }" class="app-menu__item">
            <i class="bi bi-list-task app-menu__icon"></i>
            <span class="app-menu__label">ประเภทตารางเวร</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'rate' }" class="app-menu__item">
            <i class="bi bi-list-task app-menu__icon"></i>
            <span class="app-menu__label">ประเภทค่าตอบแทน</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Holiday' }" class="app-menu__item">
            <i class="bi bi-list-task app-menu__icon"></i>
            <span class="app-menu__label">จัดการวันหยุด</span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'WorkGroupTableTypeNote' }"
            class="app-menu__item"
          >
            <i class="bi bi-list-task app-menu__icon"></i>
            <span class="app-menu__label">จัดการหมายเหตุตารางเวร</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Admin' }" class="app-menu__item">
            <i class="bi bi-list-task app-menu__icon"></i>
            <span class="app-menu__label">จัดการผู้ดูแลระบบ</span>
          </router-link>
        </li>
      </div>
    </ul>
  </aside>
</template>

<script>
import usersService from "@/services/users-service";
import { mapState } from "vuex";
export default {
  data() {
    return {
      account: {},
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    async getUser(id) {
      try {
        const res = await usersService.get(id);
        this.account = res.data.account;
      } catch (error) {
        this.showError(error);
        localStorage.removeItem("vuex");
      }
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    ...mapState(["app", "user"]),
  },
  created() {
    this.getUser(this.user.id);
  },
};
</script>

<style scoped>
.app-sidebar__user {
  display: block;
  margin-bottom: 0px;
}
</style>
